<template>
  <div class="justify-content-center">
    <Calendar
      :spec-min-date="initialDate"
      :spec-max-date="new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate() + (workspace.day_count-1))"
      :locale="getLanguage === 'cn' ? 'zh-CN' : getLanguage"
      :show-year="false"
      :enable-mousewheel-scroll="false"
      :initial-date="initialDate"
      :workspace="workspace"
      @select-date="selectDate"
    />
    <Timeslots
      ref="inlineTimeslots"
      :workspace="workspace.id"
      :service="service"
      :selected-date="selectedDate"
      @openModal="showModal"
    />
  </div>
</template>
<script>

import Calendar from '@/components/booking/calendars/inline/Calendar.vue'
import Timeslots from '@/components/booking/calendars/inline/Timeslots.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'InlineCalendar',
  components: {
    Timeslots,
    Calendar,
  },
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    service: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      initialDate: new Date(),
      selectedDate: new Date(),
    }
  },
  computed: mapGetters(['getLanguage']),
  methods: {
    setLoading(value) {
      this.$refs.inlineTimeslots.setLoading(value)
    },
    selectDate(val) {
      this.selectedDate = val
      this.$emit('select-date', val)
    },
    showModal(value) {
      this.$emit('openModal', value)
    },
  },
}
</script>

<style>
</style>
